import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_ASSEMBLY_LINE_START_APPLICATION,
} from 'api/actionTypes';

export default async function startAssemblyLineApplication(
  { state, apiClient },
  { householdApplicationId, listingId },
) {
  typeCheck('householdApplicationId::PositiveNumber', householdApplicationId);
  typeCheck('listingId::PositiveNumber', listingId);

  const assemblyLineData = await apiClient.postWithState({
    action: SR_API_ACTION_ASSEMBLY_LINE_START_APPLICATION,
    state: state,
    payload: {
      householdApplicationId,
      listingId,
    },
    onSuccess(assemblyLineData) {
      state.set(
        ['assemblyLine', 'byHouseholdListings', assemblyLineData.householdListing.id],
        assemblyLineData,
      );
    },
  });

  return assemblyLineData;
}
